import apiClient from '@u/apiClient'
import GetTemplateDashboardByIdController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/GetTemplateDashboardByIdController'
import GetTemplateDashboardElementByIdController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/GetTemplateDashboardElementByIdController'
import SubscribeToTemplateDashboardController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/SubscribeToTemplateDashboardController'
import UnsubscribeToTemplateDashboardController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/UnsubscribeToTemplateDashboardController'
import GetTemplateDashboardPublicListController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/GetTemplateDashboardPublicListController'
import CreateTemplateDashboardController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/CreateTemplateDashboardController'
import DuplicateTemplateDashboardController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/DuplicateTemplateDashboardController'
import UpdateTemplateDashboardController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardController'
import UpdateTemplateDashboardElementController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardElementController'
import UpdateTemplateDashboardUserController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardUserController'
import AddTemplateDashboardElementController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/AddTemplateDashboardElementController'
import UpdateTemplateDashboardUserPositionController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/UpdateTemplateDashboardUserPositionController'
import TemplateDashboardColumnsController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboardColumnsController'
import SetFieldTemplateDashboardController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/SetFieldTemplateDashboardController'
import OldGetDossierListsController from '@/wayfinder/actions/App/Http/Controllers/Dossier/OldGetDossierListsController'
import GetInvoiceListController from '@/wayfinder/actions/App/Http/Controllers/Invoice/GetInvoiceListController'
import GetThirdPartyCostDashboardController from '@/wayfinder/actions/App/Http/Controllers/ThirdPartyCostPayment/GetThirdPartyCostDashboardController'
import GetPaymentListController from '@/wayfinder/actions/App/Http/Controllers/Payment/GetPaymentListController'
import TemplateDashboardsController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboardsController'
import DeleteTemplateDashboardController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/DeleteTemplateDashboardController'
import GetTemplateDashboardListController from '@/wayfinder/actions/App/Http/Controllers/TemplateDashboard/GetTemplateDashboardListController'
import GenerateExportController from '@/wayfinder/actions/App/Http/Controllers/Export/GenerateExportController'

const baseErrors = {}

function processSuccessCallback(payload) {
  if (payload.successCallback) {
    payload.successCallback()
  }
}

export default {
  // region NEW DASHBOARD

  fetchTemplateDashboardById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetTemplateDashboardByIdController.get({
            template_dashboard: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          console.log('catch')
          reject(reason)
        })
    })
  },
  async fetchTemplateDashboardElementById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetTemplateDashboardElementByIdController.get({
            template_dashboard: payload.id,
            element: payload.element_id
          })
        )
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  subscribeToTemplateDashboard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SubscribeToTemplateDashboardController.post(), payload)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  async unsubscribeToTemplateDashboard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(UnsubscribeToTemplateDashboardController.post(), payload)
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  async fetchTemplateDashboardPublic() {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetTemplateDashboardPublicListController.get())
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  async createTemplateDashboard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateTemplateDashboardController.post(), payload.data)
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  async duplicateTemplateDashboard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(DuplicateTemplateDashboardController.post(), payload.data)
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  async updateTemplateDashboardById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateTemplateDashboardController.put({
            template_dashboard: payload.id
          }),
          payload.data
        )
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async updateTemplateDashboardElementById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateTemplateDashboardElementController.put({
            template_dashboard: payload.id,
            element: payload.element.id
          }),
          payload.element
        )
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async updateTemplateDashboardUserById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          UpdateTemplateDashboardUserController.put({
            template_dashboard_user: payload.id
          }),
          payload.data
        )
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async addTemplateDashboardElementById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          AddTemplateDashboardElementController.post({
            template_dashboard: payload.id,
            rowId: payload.rowId
          }),
          payload.element
        )
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  async updateTemplateDashboardUserPosition({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(UpdateTemplateDashboardUserPositionController.post(), payload)
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  // deprecated
  async updateColumnDashboard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          TemplateDashboardColumnsController.update.put({ column: payload.id }),
          payload.data
        )
        .then(async (response) => {
          resolve(response)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  setFieldToColumnDashboard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SetFieldTemplateDashboardController.put({
            template_dashboard: payload.id
          }),
          payload.data
        )
        .then((response) => {
          resolve(response)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchListDossier({ state, commit }, payload) {
    if (state.listAbortController) {
      state.listAbortController.abort()
    }
    const controller = new AbortController()
    commit('setListAbortController', controller)
    return new Promise((resolve, reject) => {
      apiClient
        .route(OldGetDossierListsController.post(), payload, {
          signal: controller.signal
        })
        .then((response) => {
          commit('setListAbortController', null)
          resolve(response)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchListInvoicingDashboard: ({ state, commit }, payload) => {
    if (state.listAbortController) {
      state.listAbortController.abort()
    }
    const controller = new AbortController()
    commit('setListAbortController', controller)
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetInvoiceListController['/api/invoicing-dashboard'].post(),
          payload,
          {
            signal: controller.signal
          }
        )
        .then((response) => {
          commit('setListAbortController', null)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchListThirdPartyCostDashboard: ({ state, commit }, payload) => {
    if (state.listAbortController) {
      state.listAbortController.abort()
    }
    const controller = new AbortController()
    commit('setListAbortController', controller)
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetThirdPartyCostDashboardController.post(), payload, {
          signal: controller.signal
        })
        .then((response) => {
          commit('setListAbortController', null)
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchListPaymentDashboard: ({ state, commit }, payload) => {
    if (state.listAbortController) {
      state.listAbortController.abort()
    }
    const controller = new AbortController()
    commit('setListAbortController', controller)
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetPaymentListController.post(), payload, {
          signal: controller.signal
        })
        .then((response) => {
          commit('setListAbortController', null)
          resolve(response)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region fetch
  async fetchDashboard({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          TemplateDashboardsController.view.get({
            template_dashboard: payload.id
          })
        )
        .then(async (response) => {
          resolve(response.data)
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },

  /*async fetchContactList({ commit }) {
     await apiClient
     .get(`api/contact`)
     .then(async (response) => {
     await commit('setContactList', response.data.contacts)
     })
     .catch(async (reason) => {
     await console.error('fetchContactList', reason)
     })
     },

     async fetchRoleContactList({ commit }, payload) {
     await apiClient
     .get(`api/contact?role=${payload.id}`)
     .then(async (response) => {
     commit('setRoleContactList', response.data.contacts)
     commit('setContactMetadata', response.data.metadata)
     })
     .catch(async (reason) => {
     console.error('fetchContactList', reason)
     })
     },

     async fetchNewContact({ commit }, predefinedRole) {
     commit('setContact', {})
     commit('auth/setErrors', baseErrors, { root: true })
     await apiClient
     .get(`api/model/new?model=contact`)
     .then(async (response) => {
     await console.log('fetchNewContact', response)

     if (predefinedRole) {
     let temp = response.data.contact
     temp.role = predefinedRole
     await commit('setContact', temp)
     } else {
     await commit('setContact', response.data.contact)
     }
     })
     .catch(async (reason) => {
     await console.error('fetchNewContact', reason)
     })
     },*/
  // endregion

  // region store
  async storeNewColumn({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(TemplateDashboardColumnsController.store.post(), payload)
      .then(async (response) => {
        if (response.status === 200) {
          // processSuccessCallback(payload)
          await commit(
            'setCurrentTemplateColumnList',
            response.data.template_column_list
          )
          await commit('setFullColumnList', response.data.full_column_list)
        }
      })
      .catch((reason) => {
        console.error('error storeNewColumn', reason)
      })
  },
  // endregion

  // region update
  async updateColumn({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(
        TemplateDashboardColumnsController.update.put({ column: payload.id }),
        payload.column
      )
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
          await commit(
            'setCurrentTemplateColumnList',
            response.data.template_column_list
          )
          await commit('setFullColumnList', response.data.full_column_list)
        }
      })
      .catch((reason) => {
        console.error('updateContact', reason)
      })
  },

  async updateTemplate({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(
        TemplateDashboardsController.update.put({
          template: payload.template.id
        }),
        payload.template
      )
      .then((response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
          commit('setTemplateList', response.data.template_list)
        }
      })
      .catch((reason) => {
        console.error('updateContact', reason)
      })
  },

  async createTemplate({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(TemplateDashboardsController.store.post(), payload.template)
      .then((response) => {
        if (response.status == 200) {
          console.log('response', response.data)
          // processSuccessCallback(payload)
          commit('setTemplateList', response.data.template_list)
          commit('setFullColumnList', response.data.column_list)
        }
      })
      .catch((reason) => {
        console.error('updateTemplate', reason)
      })
  },
  async updateTemplateName({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .post(`/api/dashboard/update-template-name`, payload)
      .then((response) => {
        if (response.status === 200) {
          // processSuccessCallback(payload)
          commit('setTemplateList', response.data.template_list)
        }
      })
      .catch((reason) => {
        console.error('updateTemplate', reason)
      })
  },

  // endregion

  // region delete
  async deleteColumn({ commit }, payload) {
    commit('auth/setErrors', baseErrors, { root: true })
    await apiClient
      .route(
        TemplateDashboardColumnsController.destroy.delete({
          column: payload.id
        })
      )
      .then(async (response) => {
        if (response.status === 200) {
          processSuccessCallback(payload)
          await commit(
            'setCurrentTemplateColumnList',
            response.data.template_column_list
          )
          await commit('setFullColumnList', response.data.full_column_list)
        }
      })
      .catch((reason) => {
        console.error('updateContact', reason)
      })
  },

  deleteTemplateDashboardById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteTemplateDashboardController.delete.delete({
            template_dashboard: payload.id
          })
        )
        .then((response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  undoDeleteTemplateDashboardById: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteTemplateDashboardController.undoDelete.get({ id: payload.id })
        )
        .then(async (response) => {
          if (response.status === 200) {
            resolve(response.data)
          }
        })
        .catch(async (reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region export
  fetchExportTemplateList({ commit }) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetTemplateDashboardListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          console.error('fetchExportTemplateList', reason)
          reject(reason)
        })
    })
  },

  generateExportFromTemplate({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        // The export page shows its own message on the 409 of an export
        // already running.
        .route(GenerateExportController.post(), payload, {
          skipConflictToast: true
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          console.error('generateExportFromTemplate', reason)
          reject(reason)
        })
    })
  }
  // endregion
}
